<template>
  <ErrorPage
    v-if="state == ApiRequestStatus.Error"
    type="systemError"
    :custom-messages="customErrorMessages"
  ></ErrorPage>
  <template v-else>
    <BaseInderterminateProgressIndicator :is-running="isLoading" />
    <slot />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseInderterminateProgressIndicator from '../base/progress-indicator/BaseInderterminateProgressIndicator.vue'
import ErrorPage from '../../../modules/app/pages/ErrorPage.vue'
import { ApiRequestStatus } from '@/core/models/api/api-request-status'

interface Props {
  state: ApiRequestStatus
  customErrorMessages?: Map<'notFound' | 'systemError' | 'forbidden', string>
}

const props = defineProps<Props>()

const isLoading = computed(
  () => props.state == ApiRequestStatus.Loading || props.state == ApiRequestStatus.Idle,
)
</script>
